<template>
  <div class="credit-card-list">
    <div
      v-for="(registeredCard, index) in registeredCreditCards"
      :key="index"
      class="radio_btn"
      :class="{
        'check-list-radio-btn': !disabled,
        'check-list-radio-btn-disabled': disabled
      }"
    >
      <input
        :id="`credit3d-${registeredCard.custCode}`"
        v-model="selectedCreditCard"
        type="radio"
        name="payment_method_form[payment_method]"
        :value="`credit3d-${registeredCard.custCode}`"
        :disabled="disabled || null"
        @change="onChange(`credit3d-${registeredCard.custCode}`)"
      />
      <label :for="`credit3d-${registeredCard.custCode}`" class="radio-label">
        <CreditCardBrand
          v-if="registeredCard.creditCardBrand"
          class="credit-card-list__credit-card-brand"
          :brand-type="registeredCard.creditCardBrand"
        />
        <span class="credit-card-list__credit-card-number">
          {{ registeredCard.creditCardNumber }}
        </span>
        <span class="credit-card-list__credit-card-expired-at">
          有効期限 {{ convertCreditCardExpiredAt(registeredCard.expiredAt) }}
        </span>
        <span
          v-if="!disabled"
          class="credit-card-list__credit-card-delete"
          @click="onClickDelete(registeredCard.custCode)"
        >
          削除
        </span>
      </label>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import CreditCardBrand from '../../molecules/credit_cards/CreditCardBrand.vue'
export default {
  components: {
    CreditCardBrand
  },
  props: {
    selectedPaymentMethod: {
      type: String,
      required: true
    },
    registeredCreditCards: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      required: true
    },
    oldSelectedCreditCard: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      selectedCreditCard: ''
    }
  },
  watch: {
    selectedPaymentMethod(newValue) {
      if (this.selectedCreditCard !== newValue) {
        this.selectedCreditCard = newValue
      }
    }
  },
  mounted() {
    this.selectedCreditCard = this.oldSelectedCreditCard
  },
  methods: {
    onChange(value) {
      this.$emit('input-credit-card', value)
    },
    onClickDelete(creditCardCustCode) {
      this.$emit('clicked', creditCardCustCode)
    },
    convertCreditCardExpiredAt(date) {
      return dayjs(date).format('MM/YY')
    }
  }
}
</script>

<style lang="scss" scoped>
.credit-card-list {
  &__credit-card-brand {
    width: 48px;
    height: 32px;
    margin-left: 8px;
    margin-right: 8px;
  }

  &__credit-card-number {
    font-size: 1.4rem;
    letter-spacing: 0.1rem;
  }

  &__credit-card-expired-at {
    padding-left: 16px;
    font-size: 1.2rem;
    letter-spacing: 0.1rem;
    color: $gray-1;
  }

  &__credit-card-delete {
    margin-left: auto;
    padding-left: 4px;
    font-size: 1.2rem;
    color: $link;
  }
}
</style>
